<template>
  <v-dialog
    v-model="dialogVisible"
    max-width="300"
    persistent
  >
    <v-card>
      <v-card-title class="headline">{{ heading }}</v-card-title>
      <v-card-text v-if="text" v-html="text"></v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn
          color="primary darken-1"
          text
          @click="$emit('cancel')"
        >
          Cancel
        </v-btn>

        <v-btn
          color="primary darken-1"
          text
          @click="$emit('confirm')"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

export default {
  data: () => ({
    //
  }),
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
      required: false,
    },
    heading : {
      default: 'Are you sure?',
      required: false,
    },
    text : {
      default: null,
      required: false,
    }
  },
  watch: {
    //
  },
  methods: {
    //
  },
  computed: {
    //
  },
  mounted() {
    //
  }
}
</script>